import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';
import cx from 'classnames';

import { LLInput } from '../../../../components';
import { trans } from '../../../../common/utils';


let searchMarketGroupInputTimeout = null;
const SearchMarketGroup = ({ searchMarketValue, setSearchMarketValue, isOpened, setOpened }) => {
    const [inputValue, setInputValue] = useState('');

    const searchInputRef = useRef(null);

    useEffect(() => {
        clearTimeout(searchMarketGroupInputTimeout);
        searchMarketGroupInputTimeout = setTimeout(() => {
            setSearchMarketValue(inputValue);
        }, 300);
    }, [inputValue]);

    useEffect(() => {
        if (isOpened) {
            searchInputRef.current?.instance.focus();
            setInputValue(searchMarketValue);
        }
    }, [isOpened]);

    return (
        <div className="market-group-search">
            <div className="market-group-search__dummy" />
            <div className={cx('market-group-search__input-wrp', isOpened && 'opened')}>
                <LLInput
                    ref={searchInputRef}
                    customClasses={cx('market-group-search__input', isOpened && 'opened')}
                    placeholder={trans('Search for market')}
                    value={inputValue}
                    onValueChanged={(e) => {
                        setInputValue(e.value);
                    }}
                />
                <i
                    className={cx('market-group-search__icon', isOpened ? 'doruk-close' : 'doruk-search-01')}
                    onClick={(e) => {
                        e.stopPropagation();
                        isOpened && setSearchMarketValue('');
                        setOpened((v) => !v);
                    }}
                ></i>
            </div>
        </div>
    );
};

export default observer(SearchMarketGroup);
